import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useDarkMode } from '@/composables/useDarkMode';
const __default__ = { inheritAttrs: false };
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'MGSelect',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const { isDarkMode } = useDarkMode();
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createBlock(_component_v_select, _mergeProps({
                class: ["mg-select", { dark: _unref(isDarkMode) }],
                "model-value": _ctx.modelValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
            }, _ctx.$attrs), _createSlots({ _: 2 }, [
                _renderList(_ctx.$slots, (_, name) => {
                    return {
                        name: name,
                        fn: _withCtx((slotData) => [
                            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData ?? {})))
                        ])
                    };
                })
            ]), 1040, ["class", "model-value"]));
        };
    }
});
